import React, { Fragment, useEffect } from 'react';
import { Paper, Table, TableCell, TableContainer, TableHead, TableRow, Typography, makeStyles, TableBody } from '@material-ui/core';

import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions/index';
import TypeAsset from './TypeAsset/TypeAsset';

const useStyle = makeStyles(theme => ({
  table: {
    minWidth: 500
  },
  topTable: {
    padding: 16,
    backgroundColor: '#FAFAFA'
  }
}))

const columns = [
  // { id: 'no', label: 'No' },
  { id: 'nama', label: 'Nama Jenis Aset' },
  { id: 'status', label: 'Status' },
  { id: 'action', label: 'Action', align:"right"}
]

const TypeAssetList = props => {
  const { onFetchTypeAssets, token, typeAssets, changing } = props;
  useEffect(() => {
    onFetchTypeAssets(token)
  },[onFetchTypeAssets, token, changing])

  const classes = useStyle();

  function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }

  let tableBody = ''
  if(!isEmpty(typeAssets)){
    tableBody = (
      
        <TableBody>
          {typeAssets.map((typeAsset, index) => (
            <TypeAsset
              typeAsset={typeAsset}
              key={typeAsset.id_type}
              index={index}
              edited={() => props.editTypeAsset(typeAsset)}
            />
          )).reverse()
          }
          {/* {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={8} />
            </TableRow>
          )} */}
        </TableBody>
      
    )
  }

  return (
    <Fragment>
      {/* {loading} */}
      <TableContainer component={Paper}>
        <div className={classes.topTable}>
          <Typography variant="h4">List Jenis Aset</Typography>
        </div>
        <hr />
        <Table className={classes.table} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {tableBody}
        </Table>
      </TableContainer>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    loadingState: state.typeAsset.loading,
    changing: state.typeAsset.changing,
    typeAssets: state.typeAsset.typeAssets,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchTypeAssets: (token) => dispatch(actions.fetchTypeAssets(token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TypeAssetList);